<template>
<div>
  <div class="xsmall-hide small-hide bg-1">
  </div>
  <div class="medium-hide large-hide xlarge-hide">
    <img src="../assets/naniungo-slide-18.jpg">
  </div>
<div class="md-layout mt-100 title">
</div>
 <div class="md-layout blog title">
   <div class="md-layout-item blog-margin">
    <h1>Themen, die uns bewegen</h1>
   </div>
</div>
<div v-for="article in articles" :key="article.name" class="md-layout mt-10 blog">
  <div class="md-layout-item mt-40  md-xlarge-size-40 md-large-size-40 md-medium-size-40 md-small-size-100 md-xsmall-size-100">
    <img :src="getImg(article.thumbnail)">
  </div>
  <div class="md-layout-item blog-margin md-xlarge-size-60 md-large-size-60 md-medium-size-60 md-small-size-100 md-xsmall-size-100">
      <h1>{{ article.title }}</h1>
      <div class="sub">
      {{ article.subtitle }}
      </div>
    <p>
      {{ article.intro }}
    </p>
   <router-link style="width:100%;"  v-bind:to="'/article/'+article.route" exact>
      <md-button style="margin-left:1px;" class="md-raised" md-menu-trigger>
        <span style="text-transform:uppercase; font-size:10px; color:$accent">
        zum artikel</span><md-icon class="green">arrow_forward</md-icon>
      </md-button>
    </router-link>
  </div>
</div>

<div class="message dark secondary mt-40">
  <router-link style="width:100%;" v-bind:to="'/karriere'" exact>
  <h1>Karrieremöglichkeiten<md-icon class="green ml-20">arrow_forward</md-icon></h1>
  </router-link>
</div>

</div>

</template>

<script>
import { mapState, mapActions } from 'vuex'

export default {
  name: 'Blog',
  data() {
    return {
      firstName: "",
      lastName: "",
      jobTitle: "",
      emailAddressPrivate: "",
      phoneNumberBusiness: "",
      hobbies: "",
      ambition: "",
      level: "",
      function: "",
      carerix_id: "",
      functionOne:"",
      method:"",
      varCandidates: [{
          "ambition" : '',
          "isOpen"  : false,
          "addtoCart": false,
          "carerix_id": ''
      }]
    }
  },
  computed: {
    ...mapState({
      candidates: state =>
      state.candidates.candidates,
      cart: state =>
      state.cart.cart,
      articles: state =>
      state.articles.articles,
    })
  },
  created() {
  // this.$store.dispatch('candidates/getCandidates');
  },
  methods: {
    ...mapActions ('candidates', 'cart', 'articles' [
        'addCandidate',
        'deleteCandidate',
        'updateCandidate',
        'getCart'
    ]),
    toggleOpen(value) {
        var item = this.varCandidates.filter(obj => {
        return obj.ambition === value
        })[0]

        if (typeof item !== "undefined") {
        item.isOpen = !item.isOpen
        }
    },
    getToggleState(value) {
        const item = this.varCandidates.filter(obj => {
        return obj.ambition === value
        })[0]
        if (typeof item !== "undefined") {
          return item.isOpen
        }
    },
    toggleCart(value) {
      // const item = this.$store.state.cart.cart.filter(obj => {
      const item = this.varCandidates.filter(obj => {      
      return obj.ambition === value
      })[0]
      if (typeof item !== "undefined") {
        item.addtoCart = !item.addtoCart
      }
    },
    getCartState(value) {
      // const item = this.$store.state.cart.cart.filter(obj => {
      const item = this.varCandidates.filter(obj => {
      return obj.ambition === value
      })[0]
      if (typeof item !== "undefined") {
        return item.addtoCart
      }
    },
    getImg(name) {
      return require("../assets/" + name);
    }
  },
  mounted() {
    // if (localStorage.getItem('toggle') === 'true' && localStorage.getItem('toggle').length ===  this.$store.state.candidates.candidates.length) {
    if (localStorage.getItem('varCandidates')) {
          this.varCandidates = JSON.parse(localStorage.getItem('varCandidates'));
    } else {
      for(var i in this.$store.state.candidates.candidates) {
        var item = this.$store.state.candidates.candidates[i];
        this.varCandidates.push({
          "ambition" : item.ambition,
          "isOpen"  : false,
          "addtoCart": false,
          "carerix_id": item.carerix_id
      });
    }
    }
  },
  watch: {
    varCandidates: {
      handler() {
      localStorage.setItem('varCandidates', JSON.stringify(this.varCandidates));
      this.$store.dispatch('cart/getCart');
      // this.getCart();
      },
    deep: true
  }
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style lang="scss" scoped>
@import '../assets/css/shared.scss';
.bg-1{
  background: url("../assets/naniungo-slide-10.jpg") no-repeat center center fixed;
  -webkit-background-size: cover;
  -moz-background-size: cover;
  -o-background-size: cover;
  background-size: cover;
  height:500px;
}
.profiles{
  margin-left:10px;
  margin-right:10px;

.md-card-header {
    padding: 16px;
}

.md-card {
    margin: 10px;
    width:55vw;
    display: inline-block;
    vertical-align: top;
  }

@media (min-width: 300px) and (max-width: 1300px) {
  .md-card {
    width:50vw;
    }
}

.md-title{
  // margin-right:80px !important;
  h3{
    font-size:30px !important;
    margin-top:-2px;
    font-weight: 900;
  }
}
.md-subhead{
  // margin-right:80px !important;
  p{
    font-size:16px !important;
    color: $primary-font;
  }
}
.md-card-actions{
  margin-bottom:5px;
  margin-right:5px;
}
}

@media (min-width: 947px) {
  .blog{
    h1{
    font-size: 50px;
    line-height: 56px;
    font-weight:300;
  }
  p{
    font-size: 20px;
    line-height: 28px;
  }
}
}
@media (max-width: 1200px) {
  .blog{
    h1{
    font-size: 25px;
    line-height: 33px;
    font-weight:300;
  }
  p{
    font-size: 13px;
    line-height: 20px;
  }
  .blog-margin{
    padding-top:5px;
    padding-left:40px;
    padding-right:40px;
    padding-bottom:40px;
}
}
}
@media (max-width: 1600px) {
  .blog{
    h1{
    font-size: 30px;
    line-height: 36px;
    font-weight:300;
  }
  p{
    font-size: 15px;
    line-height: 20px;
  }
}
}

.blog{
  margin-left:10vw; 
  margin-right:10vw;  
}


</style>
